import httpService from "./httpService";

export default {
  findAllLanhDaoThamDu(caseMasterId) {
    return httpService.get("hcCaseCalendarUserView/findAllLanhDaoThamDu", {
      params: {caseMasterId}
    });
  }
};




// WEBPACK FOOTER //
// ./src/services/hcCaseCalendarUserViewService.js